import React from "react";
import { PROFILE } from "../../data/profile";

export default function Skills() {
  const groups = Object.entries(PROFILE.skills);
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="relative py-24 sm:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-7xl px-5">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <span className="text-eyebrow">// 02 · Technical Skills</span>
            <h2 className="text-display mt-3 text-[2.6rem] sm:text-[3.4rem] leading-[0.95]">
              Tools I use to{" "}
              <em className="italic text-[var(--jewel)]">build</em>.
            </h2>
          </div>
          <p className="text-sm text-muted-foreground max-w-md">
            A curated stack for scalable backends, AI solutions and cloud-native
            applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {groups.map(([category, list], idx) => (
            <div
              key={category}
              data-testid={`skill-group-${idx}`}
              className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:border-white/20 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-serif text-xl text-foreground">{category}</h3>
                <span className="font-mono-ed text-xs text-muted-foreground">
                  {String(idx + 1).padStart(2, "0")}/{groups.length}
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {list.map((s, i) => (
                  <span
                    key={s}
                    className="pill chip-enter"
                    style={{ animationDelay: `${i * 30}ms` }}
                    data-testid={`skill-chip-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
